<img class="chl-footer__logo" src="assets/img/logos/cheelee-logo-mark-white.svg" alt="CHEELEE" />

<span class="chl-footer__copyright">All rights reserved {{ getCopyRightYears() }}</span>

<div class="chl-footer-socials">
  @for (social of socialLinks; track $index) {
    <a class="chl-footer-socials-item" [href]="social.url" target="_blank" rel="nofollow">
      <cheelee-icon size="20" [iconId]="social.icon" />
    </a>
  }
</div>

<div class="chl-footer-links-wrap">
  <div class="chl-footer-links">
    @for (link of links().splice(0,2); track $index) {
      <a class="chl-footer-links-item" [href]="link.url" target="_blank" rel="nofollow">
        {{ link.title | i18nextEager }}
      </a>
    }

  </div>

  <div class="chl-footer-links">
    @for (link of links(); track $index) {
      <a class="chl-footer-links-item" [href]="link.url" target="_blank" rel="nofollow">
        {{ link.title | i18nextEager }}
      </a>
    }
  </div>
</div>
